module.exports = __webpack_public_path__ + "media/images/malvinas/download_covid19_file-a8349788ccfebb98f5ba9aac44576fe3.svg";